import { createEventRoute } from 'utils/routes'
import CreateShow from './CreateShow'
import UpdateShow from './UpdateShow'
import ShowListSetting from './ShowListSetting'

export default {
    showList: createEventRoute({
        title: 'portal_menu.shows',
        breadcrumb: 'portal_menu.shows',
        path: '/shows',
        component: ShowListSetting,
        exact: true,
        context: 'programs'
    }),
    createShow: createEventRoute({
        title: 'portal_menu.shows_create',
        breadcrumb: 'portal_menu.shows_create',
        path: '/shows/create',
        component: CreateShow,
        exact: true,
        hasBackButton: true,
        context: 'program-create'
    }),
    updateShow: createEventRoute<{ id: number }>({
        title: 'portal_menu.shows_update',
        breadcrumb: 'portal_menu.shows_update',
        path: '/shows/:id',
        component: UpdateShow,
        exact: true,
        hasBackButton: true,
        context: 'program-update'
    })
}
